<template>
  <div>
    <div class="top-container">
      <div class="main_header" style="background-color: #f2f2f2; width: 100%; text-align: center;">
        <div class="va-logo">
          <div class="fadingEffect"></div>
          <img class="va-img" src="../../public/img/logos/va.png" />
        </div>
        <h1 style="color: #00264a; margin-top: -20px;">Random teams picker</h1>
        <br />
        <div>
          <b-form-tags
            style="width: 80%; margin: auto;"
            v-model="participants"
            no-outer-focus
            class="mb-2"
          >
            <template v-slot="{ tags, inputAttrs, inputHandlers, tagVariant, addTag, removeTag }">
              <b-input-group class="mb-2">
                <b-form-input
                  prepend="Participant Name"
                  size="lg"
                  v-bind="inputAttrs"
                  v-on="inputHandlers"
                  placeholder="New Participant - Press enter to add"
                  class="form-control"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="addTag()"
                    variant="outline-primary"
                    style="margin-left: 5px;"
                  >Add</b-button>
                  <b-button
                    @click="generateTeams()"
                    style="margin-left: 5px;"
                    variant="success"
                  >Generate teams</b-button>
                  <b-button
                    @click="clearTeams()"
                    style="margin-left: 5px;"
                    variant="danger"
                  >Clear teams</b-button>
                </b-input-group-append>
              </b-input-group>
              <div class="d-inline-block" style="font-size: 1.5rem;">
                <b-form-tag
                  v-for="tag in tags"
                  @remove="removeTag(tag)"
                  :key="tag"
                  :title="tag"
                  :variant="tagVariant"
                  class="mr-1"
                >{{ tag }}</b-form-tag>
              </div>
            </template>
          </b-form-tags>
        </div>
        <br />
        <br />
        <br />
        <br />
      </div>
    </div>
    <GearsSep />
    <div>
      <b-table id="teamsTable" class="teams-table" striped hover :items="teams"></b-table>
    </div>
  </div>
</template>

<script>
import GearsSep from "./../components/GearsSep.vue";
export default {
  data() {
    return {
      id: 0,
      participants: [],
      teams: []
    };
  },
  components: {
    GearsSep
  },

  methods: {
    clearTeams() {
      this.teams = [];
    },
    generateTeams() {
      if (this.participants.length % 3 !== 0) this.participants.push("No one");
      if (this.participants.length % 3 !== 0) this.participants.push("NO one");
      var counter = 1;
      while (this.participants.length) {
        var memberA = this.participants.splice(
          Math.floor(Math.random() * this.participants.length),
          1
        );
        var memberB = this.participants.splice(
          Math.floor(Math.random() * this.participants.length),
          1
        );
        var memberC = this.participants.splice(
          Math.floor(Math.random() * this.participants.length),
          1
        );
        this.teams.push({
          teamId: counter,
          member1: memberA[0],
          member2: memberB[0],
          member3: memberC[0]
        });
        counter++;
      }
      document
        .getElementById("teamsTable")
        .scrollIntoView({ behavior: "smooth" });
    },
    handleKeyUp(event) {
      console.log(event);
      if (event.keyCode === 13) {
        this.addName();
      }
    },
    addName() {
      var name = document.getElementById("nameField").value;
      if (name === "") return;
      document.getElementById("nameField").value = "";
      var idd = this.id + 1;
      this.participants.push({ name: name });
    }
  }
};
</script>

<style lang="scss" scoped>
.teams-table {
  width: 55%;
  margin: auto;
  -webkit-box-shadow: 4px 3px 27px 0px rgba(0, 0, 0, 0.82);
  -moz-box-shadow: 4px 3px 27px 0px rgba(0, 0, 0, 0.82);
  box-shadow: 4px 3px 27px 0px rgba(0, 0, 0, 0.82);
}

.va-logo {
  width: 100%;
}

.va-img {
  width: 43%;
  margin-bottom: 70px;
}

.fadingEffect {
  position: absolute;
  top: 50px;
  bottom: 0;
  right: 0;
  width: 0%;
  height: 300px;
  background: #f2f2f2;
  -moz-animation: showHide 3s ease-out; /* Firefox */
  -webkit-animation: showHide 3s ease-out; /* Safari and Chrome */
  -ms-animation: showHide 3s ease-out; /* IE10 */
  -o-animation: showHide 3s ease-out; /* Opera */
  animation: showHide 3s ease-out;
}
@-webkit-keyframes showHide {
  /* Chrome, Safari */
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
@-moz-keyframes showHide {
  /* FF */
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
@-ms-keyframes showHide {
  /* IE10 */
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
@-o-keyframes showHide {
  /* Opera */
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
@keyframes showHide {
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
</style>